module.exports = __webpack_public_path__ + "media/gifs/happy_dancing_dog-b7be5693.gif";